<template>
  <div class="home">
    <div class="nav">
      <div class="tips">
        <h1>打卡情况统计</h1>
        <p>根据日常打卡数据，形成可视化图表，以及查看具体打卡坐标等功能</p>
      </div>

      <div class="map">
        <div id="map-container"></div>
      </div>

      <p style="color:#BBC3D1;font-size:12px;margin-bottom:10px">点击右侧色块时间,地图显示对应地理位置</p>

      <h6>统计(随筛选条件而变)</h6>
      <table>
        <tr>
          <td>本月工作日总数</td>
          <td>{{GZRCount}}</td>
        </tr>
        <tr>
          <td>本月节假日总数</td>
          <td>{{JJRCount}}</td>
        </tr>
        <tr>
          <td>整天未打卡总数</td>
          <td>{{wdkCount[0]||0}}</td>
        </tr>
        <tr>
          <td>上班未打卡总数</td>
          <td>{{wdkCount[1]||0}}</td>
        </tr>
        <tr>
          <td>下班未打卡总数</td>
          <td>{{wdkCount[2]||0}}</td>
        </tr>
        <tr>
          <td>迟到总数</td>
          <td>{{chidaoCount}}</td>
        </tr>
        <tr>
          <td>早退总数</td>
          <td>{{zaotuiCount}}</td>
        </tr>
        <tr>
          <td>加班总数</td>
          <td>{{wdkCount[3]||0}}</td>
        </tr>
      </table>
      <!-- <div style="text-align:center;font-size:12px;margin-bottom:20px">节假日功能增加后再做&lt;未打卡&gt;有效统计</div> -->
      <h6>排序</h6>
      <select @change="sort()" v-model="sortIndex">
        <option v-for="(item,y) in sorts" :value="y" :key="item">{{item}}</option>
      </select>

      <label class="between label-group">
        <input type="checkbox" v-model="showAllTime" />
        <span>显示打卡时间</span>
      </label>
      <label class="between label-group">
        <input type="checkbox" v-model="hideSignInRangeState" />
        <span>隐藏签到范围外标识</span>
      </label>
      <label class="between label-group">
        <input type="checkbox" v-model="hideSignOutRangeState" />
        <span>隐藏签退范围外标识</span>
      </label>
      <!-- <label class="between label-group">
        <input type="checkbox" v-model="hideLine" />
        <span>隐藏色块缝隙</span>
      </label>-->
      <!-- <label class="between label-group">
        <input type="checkbox" v-model="hideNotInRange" />
        <span>隐藏范围外打卡圆点</span>
      </label>-->
    </div>
    <div class="content">
      <div class="c-header between">
        <div class="flex">
          <select class="month" v-model="currentMonth" @change="getData();getJJR()">
            <option v-for="item in 12" :value="item" :key="item">{{item}}月</option>
          </select>
          <div class="form-group">
            <div class="label">姓名检索</div>
            <input type="text" class="input-t" v-model="realname" />
          </div>

          <div class="form-group">
            <div class="label">上班时间</div>
            <select class="input-t" style="width:60px" v-model="startH" @change="parse()">
              <option :value="ltTen(item-1)" v-for="item in 24" :key="item">{{ltTen(item-1)}}</option>
            </select>
            <span style="color:#7387AA;margin:0 5px">:</span>
            <select class="input-t" style="width:60px" v-model="startM">
              <option :value="ltTen(item-1)" v-for="item in 60" :key="item">{{ltTen(item-1)}}</option>
            </select>
          </div>
          <div class="form-group">
            <div class="label">下班时间</div>
            <select class="input-t" style="width:60px" v-model="endH">
              <option :value="ltTen(item-1)" v-for="item in 24" :key="item">{{ltTen(item-1)}}</option>
            </select>
            <span style="color:#7387AA;margin:0 5px">:</span>
            <select class="input-t" style="width:60px" v-model="endM">
              <option :value="ltTen(item-1)" v-for="item in 60" :key="item">{{ltTen(item-1)}}</option>
            </select>
          </div>
          <div class="form-group">
            <div class="label">休息日(暂不可修改)</div>
            <input type="text" class="input-t" value="周日、周六" disabled />
          </div>
        </div>

        <div class="flex">
          <span class="export">导出Excel</span>
          <div class="tips flex">
            <div class="item">
              <span style="background:#2A3F61"></span>正常
            </div>
            <div class="item">
              <span style="background:#8c8578"></span>迟到/早退
            </div>
            <div class="item">
              <span style="background:#8c6364"></span>未打卡
            </div>
            <div class="item">
              <span style="background:#2A3F61">
                <i></i>
              </span>区域外
            </div>
          </div>
        </div>
      </div>

      <div class="c-footer">
        <!-- left -->
        <div class="left">
          <div class="top">
            <div class="label">部门筛选</div>
            <select v-model="currentDepartment">
              <option :value="item" v-for="item in department" :key="item">{{item}}</option>
            </select>
          </div>
        </div>

        <!-- 左侧人名列 -->
        <div class="left-users">
          <ul ref="names" @mouseover="wxsScroll=false">
            <template v-for="(item,x) in users">
              <li
                class="item"
                :class="{bg:currentX==x}"
                v-if="((item.departmentName==currentDepartment)||currentDepartment==='全部')&&(realname==''||item.realname.indexOf(realname)>-1)"
                :key="x"
                @mouseenter="showBg(x,null)"
              >
                <h1 class="between" style="font-size:12px">
                  <span>{{item.realname}}({{item.oldSignLogCount}}天)</span>
                  <span style="color:#5a6882;font-size:12px">({{item.departmentName}})</span>
                </h1>
                <h2 style="margin-top:5px" class="flex six">
                  <!-- //上班正常总数 -->

                  <div title="上班正常次数">上正:{{item.tj_sb}}</div>
                  <!-- //上班迟到总数 -->
                  <div title="上班迟到次数">迟到:{{item.tj_sbcd}}</div>
                  <!-- //上班不在范围总数 -->
                  <div title="上班班未在范围内打卡次数">上未范:{{item.tj_sbwf}}</div>
                  <!-- //下班正常总数 -->
                  <div title="下班正常次数">下正:{{item.tj_xb}}</div>
                  <!-- //下班早退总数 -->
                  <div title="下班早退次数">早退:{{item.tj_xbzt}}</div>
                  <!-- //下班不在范围总数 -->
                  <div title="下班未在范围内打卡次数">下未范:{{item.tj_xbwf}}</div>
                </h2>
              </li>
            </template>
          </ul>
        </div>

        <!-- th -->
        <div class="thead">
          <ul
            ref="thead"
            @mouseover="topScroll=true"
            style="padding-left:200px;border-bottom:1px solid #233758;position:relative;z-index:9;background:#152847"
          >
            <li>
              <dl class="th">
                <dd
                  v-for="(item,y) in endDate"
                  :key="item"
                  class="item"
                  :class="{bg:currentY==y}"
                  @mouseenter="showBg(null,y)"
                >
                  <div class="h1">{{item}}</div>
                  <div class="h2">周 {{getDay(item)}}</div>
                </dd>
              </dl>
            </li>
          </ul>
        </div>
        <!-- 内容 -->
        <div
          v-if="!tip"
          style="display:flex;line-height:30px;flex-direction:column;align-items:center;justify-content:center;position:absolute;left:0;top:0;width:100%;height:100%;z-index:100;background:rgba(0,0,0,0.5)"
        >
          <div>
            <div>提示</div>
            <br />
            <div>左侧统计会根据筛选条件动态计算</div>
            <div>鼠标左键按下单元格可拖拽浏览</div>
            <div>排序在统计下面</div>
            <div>图例在右上角</div>
            <div
              style="border:1px solid #ddd;padding:5px 10px;margin-top:15px;font-size:14px;cursor:pointer;width:100px;text-align:center"
              @click="yes()"
            >我知道了</div>
          </div>
        </div>
        <div
          class="wxs"
          ref="wxs"
          @mouseover="wxsScroll=true;topScroll=false"
          :class="{showAllTime:showAllTime,hideLine:hideLine,hideNotInRange:hideNotInRange}"
        >
          <div v-if="isLoading" style="padding:100px 0 100px 250px">正在拼命加载...</div>

          <ul style="padding-left:200px;border-bottom:1px solid #233758;">
            <template v-for="(item,x) in users">
              <li
                style="height:70px"
                :key="x"
                v-if="(item.departmentName==currentDepartment||currentDepartment==='全部')&&(realname==''||item.realname.indexOf(realname)>-1)"
              >
                <dl class="user">
                  <dd
                    v-for="(index,y) in endDate"
                    :key="y"
                    class="item"
                    :class="{bg:currentX==x||currentY==y}"
                  >
                    <div @mouseenter="showBg(x,y)" class="tb" v-if="isJJR(y)&&not(y+1)">
                      <div
                        @click="addMarker(item.signLogs2[y].inLng,item.signLogs2[y].inLat)"
                        class="block"
                        style="border-bottom:1px solid #233758"
                        :class="{
                          state1:item.signLogs2[y]&&sb(item.signLogs2[y].inTime),
                          state2:item.signLogs2[y]&&sbcd(item.signLogs2[y].inTime),
                          state3:!item.signLogs2[y]||!item.signLogs2[y].inTime,
                          state4:item.signLogs2[y]&&item.signLogs2[y].inInRange===false&&!hideSignInRangeState
                          }"
                      >
                        <span
                          v-if="item.signLogs2[y]&&item.signLogs2[y].inTime"
                        >{{item.signLogs2[y].inTime.substr(0,5)}}</span>
                        <span v-else v-html="'&nbsp;'"></span>
                      </div>
                      <div
                        @click="addMarker(item.signLogs2[y].outLng,item.signLogs2[y].outLat)"
                        class="block"
                        :class="{
                          state1:item.signLogs2[y]&&xb(item.signLogs2[y].outTime),
                          state2:item.signLogs2[y]&&xbzt(item.signLogs2[y].outTime),
                          state3:!item.signLogs2[y]||!item.signLogs2[y].outTime,
                          state4:item.signLogs2[y]&&item.signLogs2[y].outInRange===false&&!hideSignOutRangeState
                          }"
                      >
                        <span
                          v-if="item.signLogs2[y]&&item.signLogs2[y].outTime"
                        >{{(item.signLogs2[y].outTime.substr(0,5))}}</span>
                        <span v-else v-html="'&nbsp;'"></span>
                      </div>
                    </div>

                    <div v-else class="tb" @mouseenter="showBg(x,y)">
                      <div
                        @click="addMarker(item.signLogs2[y].inLng,item.signLogs2[y].inLat)"
                        class="block"
                        :class="{state1:item.signLogs2[y]&&item.signLogs2[y].inTime}"
                      >
                        <span
                          v-if="item.signLogs2[y]&&item.signLogs2[y].inTime"
                        >{{(item.signLogs2[y].inTime.substr(0,5))}}</span>
                        <span v-else v-html="'&nbsp;'"></span>
                      </div>
                      <div
                        @click="addMarker(item.signLogs2[y].outLng,item.signLogs2[y].outLat)"
                        class="block"
                        :class="{state1:item.signLogs2[y]&&item.signLogs2[y].outTime}"
                      >
                        <span
                          v-if="item.signLogs2[y]&&item.signLogs2[y].outTime"
                        >{{item.signLogs2[y].outTime.substr(0,5)}}</span>
                        <span v-else v-html="'&nbsp;'"></span>
                      </div>
                    </div>
                  </dd>
                </dl>
              </li>
            </template>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import HelloWorld from "@/components/HelloWorld.vue";
export default {
  name: "Home",
  components: {
    HelloWorld,
  },
  computed: {
    //整天未打卡
    wdkCount() {
      //整天
      let count = 0;
      //上班
      let sbCount = 0;
      //下班
      let xbCount = 0;
      //加班
      let jbCount = 0;
      if (this.users[0] && this.JJR && this.JJR.length > 0) {
        // console.log(this.users[0].signLogs2);
        // console.log(this.JJR[0]);
        //遍历本人本月每日的打卡
        this.users.forEach((user) => {
          if (
            (this.currentDepartment == "全部" ||
              user.departmentName == this.currentDepartment) &&
            (this.realname == "" || user.realname.indexOf(this.realname) > -1)
          ) {
            user.signLogs2.forEach((log, index) => {
              //如果是本月截止到今日,否则为月底
              var endIndex =
                this.currentMonth == new Date().getMonth() + 1
                  ? new Date().getDate()
                  : this.endDate;

              if (index < endIndex) {
                if (this.JJR[index].typename != "工作日" && log.inTime) {
                  jbCount++;
                }

                if (
                  this.JJR[index].typename == "工作日" &&
                  !log.inTime &&
                  !log.outTime
                ) {
                  count++;
                }

                if (this.JJR[index].typename == "工作日" && !log.inTime) {
                  sbCount++;
                }

                if (this.JJR[index].typename == "工作日" && !log.outTime) {
                  xbCount++;
                }
              }
            });
          }
        });
      }
      return [count, sbCount, xbCount, jbCount];
    },
    chidaoCount() {
      let count = 0;
      this.users.forEach((user) => {
        if (
          (this.currentDepartment == "全部" ||
            user.departmentName == this.currentDepartment) &&
          (this.realname == "" || user.realname.indexOf(this.realname) > -1)
        ) {
          count += user.tongji[1];
        }
      });
      return count;
    },
    zaotuiCount() {
      let count = 0;
      this.users.forEach((user) => {
        if (
          (this.currentDepartment == "全部" ||
            user.departmentName == this.currentDepartment) &&
          (this.realname == "" || user.realname.indexOf(this.realname) > -1)
        ) {
          count += user.tongji[4];
        }
      });
      return count;
    },
  },
  data() {
    return {
      tip: localStorage.tip,
      sortIndex: 1,
      sorts: [
        "(正)打卡天数",
        "(倒)打卡天数",

        "(正)正常上班次数",
        "(倒)正常上班次数",
        "(正)迟到次数",
        "(倒)迟到次数",
        "(正)上班未在范围打卡次数",
        "(倒)上班未在范围打卡次数",

        "(正)正常下班次数",
        "(倒)正常下班次数",
        "(正)早退次数",
        "(倒)早退次数",
        "(正)下班未在范围打卡次数",
        "(倒)下班未在范围打卡次数",
      ],
      isLoading: false,
      showAllTime: true,
      hideSignInRangeState: false,
      hideSignOutRangeState: false,
      hideLine: false,
      hideNotInRange: false,
      realname: "",
      currentDepartment: "全部",
      currentYear: "2020",
      currentMonth: new Date().getMonth() + 1,
      startDate: null,
      endDate: null,
      startH: "08",
      startM: "30",
      endH: "17",
      endM: "30",
      currentX: -1,
      currentY: -1,
      wxsScroll: false,
      topScroll: true,
      users: [],
      department: [
        "全部",
        "总经办",
        "财务部",
        "综合部",
        "软件研发部",
        "策划咨询部",
        "工程设计部",
        "市场部",
      ],
      JJR: [],
      GZRCount: 0,
      JJRCount: 0,

      //map
      map: null,
      currentMarker: null,
      circle: [],
      //map
    };
  },
  mounted() {
    this.scrollListen();
    //map初始化
    this.map = new AMap.Map("map-container", {
      zoom: 11, //级别
      center: [116.397428, 39.90923], //中心点坐标
      // viewMode:'3D'//使用3D视图
    });

    let circles = [
      new AMap.Circle({
        // center: new AMap.LngLat(126.62797 , 45.66438),  // 圆心位置
        center: new AMap.LngLat(126.613298, 45.712337), // 圆心位置
        radius: 150, // 圆半径
        fillColor: "rgba(0,157,255,0.3)", // 圆形填充颜色
        strokeColor: "#fff", // 描边颜色
        strokeWeight: 2, // 描边宽度
      }),
      new AMap.Circle({
        // center: new AMap.LngLat(126.62797 , 45.66438),  // 圆心位置
        center: new AMap.LngLat(126.647314, 45.767771), // 圆心位置
        radius: 150, // 圆半径
        fillColor: "rgba(0,157,255,0.3)", // 圆形填充颜色
        strokeColor: "#fff", // 描边颜色
        strokeWeight: 2, // 描边宽度
      }),
    ];

    this.circle = circles;
    this.circle.forEach((item) => {
      this.map.add(item);
    });
  },
  created() {
    this.getData();
    this.getJJR();
  },
  methods: {
    //addMarker
    addMarker(lng, lat) {
      if (this.currentMarker) {
        this.currentMarker.setPosition([lng, lat]);
        this.map.setZoomAndCenter(14, [lng, lat]);
        return;
      }
      this.currentMarker = new AMap.Marker({
        position: new AMap.LngLat(lng, lat), // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
      });

      // // 将创建的点标记添加到已有的地图实例：
      this.map.setZoomAndCenter(14, [lng, lat]);

      this.map.add(this.currentMarker);

      // // 移除已创建的 marker
      // map.remove(marker);
    },
    yes() {
      this.tip = localStorage.tip = "hide";
    },
    //是否是节假日
    isJJR(y) {
      if (this.JJR && this.JJR.length > 0 && this.JJR[y]) {
        if (this.JJR[y].typename == "假日" || this.JJR[y].typename == "节日") {
          return false;
        } else {
          return true;
        }
      } else {
        return getDay(y + 1) != "六" && getDay(y + 1) != "日";
      }
    },
    //节假日获取
    getJJR() {
      this.$http
        .get("http://oa.hljzztech.com/sign/getDate?month=" + this.currentMonth)
        .then((res) => {
          if (res.data && res.data.data && res.data.data.length > 0) {
            this.JJRCount = 0;
            this.GZRCount = 0;
            //核算节假日工作日总数
            res.data.data.forEach((item) => {
              if (item.typename == "假日" || item.typename == "节日") {
                this.JJRCount++;
              } else {
                this.GZRCount++;
              }
            });
            this.JJR = res.data.data;
          }
        });
    },
    sort() {
      let sortFuns = [
        sortBySignLogLengthAsc,
        sortBySignLogLengthDesc,
        sortBySbAsc,
        sortBySbDesc,
        sortBySbCdAsc,
        sortBySbCdDesc,
        sortBySbWfAsc,
        sortBySbWfDesc,
        sortByxbAsc,
        sortByxbDesc,
        sortByxbZtAsc,
        sortByxbZtDesc,
        sortByxbWfAsc,
        sortByxbWfDesc,
      ];
      //打卡天数倒序
      function sortBySignLogLengthAsc(a, b) {
        return a.signLogs.length - b.signLogs.length;
      }
      //打卡天数倒序
      function sortBySignLogLengthDesc(a, b) {
        return b.signLogs.length - a.signLogs.length;
      }
      //正常上班次数倒序
      function sortBySbAsc(a, b) {
        return a.tj_sb - b.tj_sb;
      }
      //正常上班次数倒序
      function sortBySbDesc(a, b) {
        return b.tj_sb - a.tj_sb;
      }
      //迟到次数倒序
      function sortBySbCdAsc(a, b) {
        return a.tj_sbcd - b.tj_sbcd;
      }
      //迟到次数倒序
      function sortBySbCdDesc(a, b) {
        return b.tj_sbcd - a.tj_sbcd;
      }
      //上班未在范围倒序
      function sortBySbWfAsc(a, b) {
        return a.tj_sbwf - b.tj_sbwf;
      }
      //上班未在范围倒序
      function sortBySbWfDesc(a, b) {
        return b.tj_sbwf - a.tj_sbwf;
      }

      //正常下班倒序
      function sortByxbAsc(a, b) {
        return a.tj_xb - b.tj_xb;
      }
      //正常下班倒序
      function sortByxbDesc(a, b) {
        return b.tj_xb - a.tj_xb;
      }

      //早退次数倒序
      function sortByxbZtAsc(a, b) {
        return a.tj_xbzt - b.tj_xbzt;
      }
      //早退次数倒序
      function sortByxbZtDesc(a, b) {
        return b.tj_xbzt - a.tj_xbzt;
      }
      //上班未在范围倒序
      function sortByxbWfAsc(a, b) {
        return a.tj_xbwf - b.tj_xbwf;
      }
      //上班未在范围倒序
      function sortByxbWfDesc(a, b) {
        return b.tj_xbwf - a.tj_xbwf;
      }

      this.users.sort(sortFuns[this.sortIndex]);
    },
    not(y) {
      if (this.currentMonth == new Date().getMonth() + 1) {
        if (y <= new Date().getDate()) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    },
    getDay(day) {
      var weeks = new Array("日", "一", "二", "三", "四", "五", "六");
      return weeks[
        new Date(
          `2020-${
            this.currentMonth < 10 ? "0" + this.currentMonth : this.currentMonth
          }-${day < 10 ? "0" + day : day}`
        ).getDay()
      ];
    },
    getData() {
      let currentYear = this.currentYear;
      let currentMonth = this.currentMonth;
      let startDate = new Date(currentYear, currentMonth, 1).getDate();
      this.startDate = startDate;
      let endDate = new Date(currentYear, currentMonth, 0).getDate();
      this.endDate = endDate;

      this.isLoading = true;
      this.users = [];
      var url = "http://oa.hljzztech.com/sign/findAllByDate?currentYear=";
      // var url = "http://localhost:7001/sign/findAllByDate?currentYear=";
      this.$http
        .get(url + this.currentYear + "&currentMonth=" + this.currentMonth)
        .then((res) => {
          this.isLoading = false;
          if (res.data && res.data.data && res.data.data.length > 0) {
            this.parse(res.data.data);
            this.sort();
          } else {
            this.users = [];
          }
        });
    },

    userItemTongji(logs) {
      //上班，迟到，上班未在范围,下班，早退，下班未在范围
      var res = [0, 0, 0, 0, 0, 0];
      logs.forEach((log) => {
        if (this.sb(log.inTime)) res[0]++;
        if (this.sbcd(log.inTime)) res[1]++;
        if (log.inInRange == false) res[2]++;
        if (this.xb(log.outTime)) res[3]++;
        if (this.xbzt(log.outTime)) res[4]++;
        if (log.outInRange == false) res[5]++;
      });
      return res;
    },

    sb(time) {
      return time < this.startH + ":" + this.startM + ":59";
    },
    sbcd(time) {
      return time >= this.startH + ":" + this.startM + ":59";
    },
    xb(time) {
      return time >= this.endH + ":" + this.endM;
    },
    xbzt(time) {
      return time < this.endH + ":" + this.endM;
    },
    parse(res) {
      res = res || this.users;
      //本月休息日总数
      // var xxrCount = 0;
      // for (var i = 1; i <= this.endDate; i++) {
      //   if (this.getDay(i) == "六" || this.getDay(i) == "日") xxrCount++;
      // }
      // console.log(xxrCount);
      res.forEach((users) => {
        var newLog = "0".repeat(this.endDate).split("");

        //记录原始打卡总数
        users.oldSignLogCount = users.signLogs.length;

        users.tongji = this.userItemTongji(users.signLogs);
        users.tj_sb = users.tongji[0];
        users.tj_sbcd = users.tongji[1];
        users.tj_sbwf = users.tongji[2];
        users.tj_xb = users.tongji[3];
        users.tj_xbzt = users.tongji[4];
        users.tj_xbwf = users.tongji[5];

        if (users.signLogs && users.signLogs.length > 0) {
          //核算总数
          users.signLogs.forEach((log) => {
            if (log.date && log.date.split(":")[2]) {
              newLog[parseInt(log.date.split(":")[2]) - 1] = log;
            }
          });
        }

        users.signLogs2 = newLog;
      });

      this.users = res;
    },
    ltTen(m) {
      return m < 10 ? "0" + m : m;
    },
    showBg(x, y) {
      if (x != null) this.currentX = x;
      if (y != null) this.currentY = y;
    },
    scrollListen() {
      this.$refs.names.onscroll = () => {
        if (this.wxsScroll) return;
        this.$refs.wxs.scrollTop = this.$refs.names.scrollTop;
      };
      this.$refs.wxs.onscroll = () => {
        if (this.wxsScroll) {
          this.$refs.names.scrollTop = this.$refs.wxs.scrollTop;
        }
        if (!this.topScroll) {
          this.$refs.thead.scrollLeft = this.$refs.wxs.scrollLeft;
        }
      };

      this.$refs.thead.onscroll = () => {
        if (!this.topScroll) return;
        this.$refs.wxs.scrollLeft = this.$refs.thead.scrollLeft;
      };

      this.$refs.wxs.onmousedown = (e) => {
        var { pageX: fpageX, pageY: fpageY } = e;
        var wxsScrollLeft = this.$refs.wxs.scrollLeft;
        var wxsScrollTop = this.$refs.wxs.scrollTop;
        this.$refs.wxs.onmousemove = (ee) => {
          let { pageX, pageY } = ee;

          this.$refs.wxs.scrollLeft = wxsScrollLeft + (pageX - fpageX) * -1;
          this.$refs.wxs.scrollTop = wxsScrollTop + (pageY - fpageY) * -1;
        };
      };
      document.body.onmouseup = () => {
        this.$refs.wxs.onmousemove = null;
      };
    },
  },
};
</script>


<style lang="less" scope>
@import "../assets/less/index.less";
</style>